import { computed, ref } from 'vue'
import { defineStore } from 'pinia'
import type { UserT } from '@/types/User'
import { writeStorage } from '@/composables/useStorage'

export const useUserStore = defineStore('user', () => {
  const user = ref<UserT | null>(null)
  const isKiddiesAccount = computed(() => user.value?.isLetoUser ?? false)

  const setUser = (newUser: UserT) => {
    user.value = newUser
    writeStorage('session', 'user', JSON.stringify(newUser))
  }

  return { user, setUser, isKiddiesAccount }
})
